module.exports = __webpack_public_path__ + "img/5-2.f88dab80.svg";